module.exports = __webpack_public_path__ + "static/img/01.6a6f08f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/thuer/01.jpg
// module id = 456
// module chunks = 1